import { Injectable } from '@angular/core';
import {StorageTipo} from '@appNeo/neoCore/helpers/enums/storage-tipo.enum';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  set(key: string, value: string, storage: StorageTipo) {
    switch (storage) {
      case StorageTipo.LocalStorage:
        localStorage.setItem(key, value);
        break;
      case StorageTipo.SessionStorage: 
        sessionStorage.setItem(key, value);
        break;
    }
  }

  get(key: string, storage: StorageTipo) {
    switch (storage) {
      case StorageTipo.LocalStorage:
        return localStorage.getItem(key);
      case StorageTipo.SessionStorage: 
        return sessionStorage.getItem(key);
    }
  }

  remove(key: string, storage: StorageTipo) {
    switch (storage) {
      case StorageTipo.LocalStorage:
        localStorage.removeItem(key);
        break;
      case StorageTipo.SessionStorage: 
        sessionStorage.removeItem(key);
        break;
    }
  }
  clear(storage: StorageTipo) {
    switch (storage) {
      case StorageTipo.LocalStorage:
        localStorage.clear();
        break;
        case StorageTipo.SessionStorage: 
        sessionStorage.clear();
        break;
    }
  }}
